export default __webpack_public_path__ + "static/our-story-4fd0582641b1148539998a682c2eb702.svg";